<template>
    <div>
        <ec-tabela-listagem
            ref="listagem"
            :url-sistema="urlSistema"
            rotulo-itens="usuários"
            texto-vazio="Nenhum usuário cadastrado."
            placeholder-busca="Buscar por nome, CPF ou e-mail"
            :link-linha="visualizar ? (pessoa => urlSistema + '/' + pessoa.id) : null"
        >
            <template v-slot:botaonovo>
                <slot name="botaonovo"></slot>
            </template>

            <template v-slot:acoes="{ item }">
                <a v-if="visualizar" :href="urlSistema+'/'+item.id" class="btn btn-sm ec-acao" v-b-tooltip.hover title="Visualizar" aria-label="Visualizar"><b-icon icon="eye-fill"></b-icon></a>
                <a v-if="editar" :href="urlSistema+'/'+item.id+'/edit'" class="btn btn-sm ec-acao" v-b-tooltip.hover title="Editar" aria-label="Editar"><b-icon icon="pencil-fill"></b-icon></a>
                <button v-if="excluir" type="button" class="btn btn-sm ec-acao ec-acao--perigo" v-b-tooltip.hover title="Excluir" aria-label="Excluir" @click="selecionarPessoaExcluir(item)"><b-icon icon="trash-fill"></b-icon></button>
            </template>
        </ec-tabela-listagem>

        <usuario-modal-exclusao @exclusaoconcluida="$refs.listagem.recarregar()" v-if="pessoaSelecionada" id="ExclusaoPessoa" :url-redirect="'/'+urlSistema+'/'" :url-sistema="urlSistema" :pessoa="pessoaSelecionada">
            <template v-slot:titulo>
                EXCLUSÃO DE USUÁRIO
            </template>
        </usuario-modal-exclusao>
    </div>
</template>

<script>
export default {
    props:
    {
        urlSistema:{type:String,required:true},
        novo:{type:Boolean,required:true},
        visualizar:{type:Boolean,required:true},
        editar:{type:Boolean,required:true},
        excluir:{type:Boolean,required:true},
        classe:{
            type:String,
            required:false
        }
    },
    data(){
        return{
            pessoaSelecionada:{},
        }
    },
    methods:{
        selecionarPessoaExcluir(pessoa){
            this.pessoaSelecionada = pessoa
            $('#ExclusaoPessoa').modal('show');
        },
    }
}
</script>
